import { render, staticRenderFns } from "./AiPage.vue?vue&type=template&id=9a54274e&scoped=true"
import script from "./AiPage.vue?vue&type=script&lang=js"
export * from "./AiPage.vue?vue&type=script&lang=js"
import style0 from "./AiPage.vue?vue&type=style&index=0&id=9a54274e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a54274e",
  null
  
)

export default component.exports